import { gql } from '@apollo/client';

export const PARTNERSHIP_FIELDS = gql`
    fragment PartnershipFields on partnerships {
        carrier_alias
        carrier_id
        contractor_id
        partnership_id
        share_manifests
        shipper_alias
        shipper_id
        shipper_label
        status
        profile_img
        profile_img_color
    }
`;
